import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

function initials(name) {
    if (!name) return "?";
    return name.split(" ").filter(Boolean).slice(0, 2).map(n => n[0]?.toUpperCase()).join("");
}

export default function UserCell({ name, subtitle, avatarUrl, size = "md" }) {
    const sizes = {
        sm: "h-8 w-8 text-[10px]",
        md: "h-10 w-10 text-[11px]",
        lg: "h-14 w-14 text-[15px]",
    };
    return (
        <div className="flex items-center gap-3 min-w-0">
            <Avatar className={sizes[size] || sizes.md}>
                <AvatarImage src={avatarUrl || undefined} alt={name} />
                <AvatarFallback className="bg-[hsl(var(--brand))] text-white font-bold">
                    {initials(name)}
                </AvatarFallback>
            </Avatar>
            <div className="min-w-0">
                <div className="truncate text-[13px] font-semibold text-foreground">{name || "—"}</div>
                {subtitle && <div className="truncate text-[11.5px] text-muted-foreground">{subtitle}</div>}
            </div>
        </div>
    );
}
